/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerBillDTO,
  PaymentNumberLinkDTO,
  PushRequestDTO,
  PushResponseDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Trigger a push payment
 * @summary Trigger push payment
 */
export const triggerPushPayment = (
    pushRequestDTO: PushRequestDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PushResponseDTO>(
      {url: `/api/frontend/payments/push`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushRequestDTO, signal
    },
      options);
    }
  


export const getTriggerPushPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerPushPayment>>, TError,{data: PushRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof triggerPushPayment>>, TError,{data: PushRequestDTO}, TContext> => {

const mutationKey = ['triggerPushPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof triggerPushPayment>>, {data: PushRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  triggerPushPayment(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TriggerPushPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof triggerPushPayment>>>
    export type TriggerPushPaymentMutationBody = PushRequestDTO
    export type TriggerPushPaymentMutationError = unknown

    /**
 * @summary Trigger push payment
 */
export const useTriggerPushPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof triggerPushPayment>>, TError,{data: PushRequestDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof triggerPushPayment>>,
        TError,
        {data: PushRequestDTO},
        TContext
      > => {

      const mutationOptions = getTriggerPushPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Link a phone number for payments
 * @summary Link phone number
 */
export const linkPhoneNumber = (
    paymentNumberLinkDTO: PaymentNumberLinkDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentNumberLinkDTO>(
      {url: `/api/frontend/payments/link-number`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentNumberLinkDTO, signal
    },
      options);
    }
  


export const getLinkPhoneNumberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkPhoneNumber>>, TError,{data: PaymentNumberLinkDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof linkPhoneNumber>>, TError,{data: PaymentNumberLinkDTO}, TContext> => {

const mutationKey = ['linkPhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkPhoneNumber>>, {data: PaymentNumberLinkDTO}> = (props) => {
          const {data} = props ?? {};

          return  linkPhoneNumber(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LinkPhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof linkPhoneNumber>>>
    export type LinkPhoneNumberMutationBody = PaymentNumberLinkDTO
    export type LinkPhoneNumberMutationError = unknown

    /**
 * @summary Link phone number
 */
export const useLinkPhoneNumber = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkPhoneNumber>>, TError,{data: PaymentNumberLinkDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkPhoneNumber>>,
        TError,
        {data: PaymentNumberLinkDTO},
        TContext
      > => {

      const mutationOptions = getLinkPhoneNumberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Activate a linked phone number
 * @summary Activate phone number
 */
export const activatePhoneNumber = (
    paymentNumberLinkDTO: PaymentNumberLinkDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentNumberLinkDTO>(
      {url: `/api/frontend/payments/activate-number`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: paymentNumberLinkDTO, signal
    },
      options);
    }
  


export const getActivatePhoneNumberMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePhoneNumber>>, TError,{data: PaymentNumberLinkDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activatePhoneNumber>>, TError,{data: PaymentNumberLinkDTO}, TContext> => {

const mutationKey = ['activatePhoneNumber'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activatePhoneNumber>>, {data: PaymentNumberLinkDTO}> = (props) => {
          const {data} = props ?? {};

          return  activatePhoneNumber(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivatePhoneNumberMutationResult = NonNullable<Awaited<ReturnType<typeof activatePhoneNumber>>>
    export type ActivatePhoneNumberMutationBody = PaymentNumberLinkDTO
    export type ActivatePhoneNumberMutationError = unknown

    /**
 * @summary Activate phone number
 */
export const useActivatePhoneNumber = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activatePhoneNumber>>, TError,{data: PaymentNumberLinkDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activatePhoneNumber>>,
        TError,
        {data: PaymentNumberLinkDTO},
        TContext
      > => {

      const mutationOptions = getActivatePhoneNumberMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get linked phone numbers for the current user
 * @summary Get linked numbers
 */
export const getLinkedNumbers = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentNumberLinkDTO[]>(
      {url: `/api/frontend/payments/linked-numbers`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLinkedNumbersInfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/payments/linked-numbers`
    ] as const;
    }

export const getGetLinkedNumbersQueryKey = () => {
    return [
    `/api/frontend/payments/linked-numbers`
    ] as const;
    }

    
export const getGetLinkedNumbersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLinkedNumbers>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedNumbersInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedNumbers>>> = ({ signal }) => getLinkedNumbers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLinkedNumbersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedNumbers>>>
export type GetLinkedNumbersInfiniteQueryError = unknown


export function useGetLinkedNumbersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLinkedNumbers>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedNumbers>>,
          TError,
          Awaited<ReturnType<typeof getLinkedNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinkedNumbersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLinkedNumbers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedNumbers>>,
          TError,
          Awaited<ReturnType<typeof getLinkedNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinkedNumbersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLinkedNumbers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get linked numbers
 */

export function useGetLinkedNumbersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLinkedNumbers>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLinkedNumbersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLinkedNumbersQueryOptions = <TData = Awaited<ReturnType<typeof getLinkedNumbers>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLinkedNumbersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLinkedNumbers>>> = ({ signal }) => getLinkedNumbers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLinkedNumbersQueryResult = NonNullable<Awaited<ReturnType<typeof getLinkedNumbers>>>
export type GetLinkedNumbersQueryError = unknown


export function useGetLinkedNumbers<TData = Awaited<ReturnType<typeof getLinkedNumbers>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedNumbers>>,
          TError,
          Awaited<ReturnType<typeof getLinkedNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinkedNumbers<TData = Awaited<ReturnType<typeof getLinkedNumbers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLinkedNumbers>>,
          TError,
          Awaited<ReturnType<typeof getLinkedNumbers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLinkedNumbers<TData = Awaited<ReturnType<typeof getLinkedNumbers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get linked numbers
 */

export function useGetLinkedNumbers<TData = Awaited<ReturnType<typeof getLinkedNumbers>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLinkedNumbers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLinkedNumbersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get bills for the current user
 * @summary Get bills
 */
export const getBills = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerBillDTO[]>(
      {url: `/api/frontend/payments/bills`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBillsInfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/payments/bills`
    ] as const;
    }

export const getGetBillsQueryKey = () => {
    return [
    `/api/frontend/payments/bills`
    ] as const;
    }

    
export const getGetBillsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getBills>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBills>>> = ({ signal }) => getBills(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBillsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getBills>>>
export type GetBillsInfiniteQueryError = unknown


export function useGetBillsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBills>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBills>>,
          TError,
          Awaited<ReturnType<typeof getBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBillsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBills>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBills>>,
          TError,
          Awaited<ReturnType<typeof getBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBillsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBills>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get bills
 */

export function useGetBillsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getBills>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBillsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetBillsQueryOptions = <TData = Awaited<ReturnType<typeof getBills>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBills>>> = ({ signal }) => getBills(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetBillsQueryResult = NonNullable<Awaited<ReturnType<typeof getBills>>>
export type GetBillsQueryError = unknown


export function useGetBills<TData = Awaited<ReturnType<typeof getBills>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBills>>,
          TError,
          Awaited<ReturnType<typeof getBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBills<TData = Awaited<ReturnType<typeof getBills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBills>>,
          TError,
          Awaited<ReturnType<typeof getBills>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetBills<TData = Awaited<ReturnType<typeof getBills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get bills
 */

export function useGetBills<TData = Awaited<ReturnType<typeof getBills>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBills>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetBillsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




